import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private queryRegex = new RegExp(/([^\?]+)(\?.*)?/i);

  forceNavigate: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private location: Location
  ) { }

  /**
   * Navigate to a route according given options
   * @param data navigation options
   */
  navigate(data) {
    const _type = data.type || null;

    switch (_type) {
      case 'basic':
        this.navigateBySteps(data.stepsBack || 1);
        break;

      case 'parent':
        this.navigateToParent(data);
        break;

      case 'basicWithoutQuery':
        this.setSteps(data.stepsBack || 1);
        break;

      default:
        this.location.back();
        break;
    }
  }

  /**
   * Navigate back to a route indicanting
   * the amount of steps to go back
   * @param steps Number of steps to go back
   */
  private navigateBySteps(steps) {
    this.activeRoute.queryParams.subscribe(params => {
      const _url = this.router.url.split('/')
        .slice(0, this.router.url.split('/').length - steps)
        .join('/');

      this.router.navigate([_url], { queryParams: params });
    }).unsubscribe();
  }

  private setSteps(steps) {
    const _url = this.router.url.split('/')
      .slice(0, this.router.url.split('/').length - steps)
      .join('/');

    this.router.navigate([_url]);
  }

  /*
  * Navigate to a parent route
  */
  private navigateToParent(data) {
    const _option = this.router.url.split('/')[data.stepParams];
    const _url = data.parentUrl.replace(':val', _option);
    const url = _url.split('?').slice(0, 1).join('');

    const queryString = this.router.url.substring(_url.indexOf('?') + 1);

    this.router.navigate([url], {
      queryParamsHandling: 'merge'
    });
  }

  private parseQueryString(queryString) {
    const params = {};
    let queries = '';
    let temp: any = '';
    let i = 0;
    let l = 0;

    if (queryString.indexOf('/') !== -1)
      return {};

    // Split into key/value pairs
    queries = queryString.split('&');

    // Convert the array of strings into an object
    for (i = 0, l = queries.length; i < l; i++) {
      temp = queries[i].split('=');
      params[temp[0]] = temp[1];
    }
    return params || {};
  }
}
